import { useRecoilValue } from "recoil";
import { tasksListSearchAtom } from "../miscellaneous/tasksListSearchAtom";

export const useTasksListSearchValue = () => {
  return useRecoilValue(tasksListSearchAtom);
};
